import React from 'react';
import Breadcrumb from '../shared/Breadcrumb';
import AppoinmentList from './shared/AppoinmentList';
import SideNav from './shared/SideNav';

const Appoinments = () => {
    return (  
        <div>
            <Breadcrumb title="Appoinment List"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='appoinments' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <AppoinmentList /> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Appoinments;